export default __webpack_public_path__ + "static/media/mximg2.27abc554.webp";